import { Component, Input } from '@angular/core';

@Component({
  selector: 'tab',
  template: `
    <div [hidden]="!active" class="tab-pane">
      <ng-content></ng-content>
    </div>
    `
})
export class TabComponent {
  @Input() title: string;
  @Input() active = false;
}



// WEBPACK FOOTER //
// ./src/app/shared/components/tabs/tab/tab.component.ts